import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Block } from '../partials';

const propTypes = {
    title: PropTypes.string,
    blocks: PropTypes.array,
    created_at: PropTypes.string,
};

const defaultProps = {
    title: 'Books',
    blocks: [],
    created_at: null,
};

const NewsLayout = ({ title, blocks, created_at }) => (
    <div className="layout layout-news">
        <h4 className="news-date">
            <span>{ moment(created_at).format('D MMMM YYYY') }</span>
        </h4>
        <h1 className="title news-title">{title}</h1>
        <Block
            blocks={(blocks || []).map(block => ({
                ...block,
                rounded: false,
                border: false,
            }))}
        />
    </div>
);

NewsLayout.propTypes = propTypes;
NewsLayout.defaultProps = defaultProps;

export default NewsLayout;



// WEBPACK FOOTER //
// ./components/layouts/NewsLayout.jsx